import { STORAGE_KEYS } from './useAuth';

export function useOrganisation() {
	const set = (organisation: string) => {
		localStorage.setItem(STORAGE_KEYS.organisation, organisation);
	};

	const get = () => {
		return localStorage.getItem(STORAGE_KEYS.organisation);
	};

	return {
		set,
		get,
	};
}
